<div class="layout-wrapper flex min-h-screen">
  <app-private-sidebar [menuItems]="menuItems()" />

  <div class="layout-body flex flex-col flex-1 min-w-0"
    [class.body-expanded]="isSidebarExpanded()"
    [class.body-collapsed]="!isSidebarExpanded()">
    <app-private-toolbar />

    <app-page-header>
      <app-onboarding-help-button />
    </app-page-header>

    <main class="layout-content flex-1 min-w-0 min-h-0">
      <router-outlet />
    </main>
  </div>
</div>

<app-onboarding-shell />

@if (bidSidebarService.isOpen() && bidSidebarService.data(); as bidDetail) {
  <button
    id="bid-sidebar-overlay"
    type="button"
    class="app-slide-sidebar-overlay fixed inset-0 z-[1200] bg-black/40 lg:bg-black/25"
    (click)="bidSidebarService.close()"
    [attr.aria-label]="'common.close' | translate"
  ></button>

  <div id="bid-sidebar-container" class="app-slide-sidebar-container fixed top-0 right-0 z-[1300] h-screen w-full sm:w-[30rem] lg:w-[32rem]">
    <app-bid-details-sidebar
      [data]="bidDetail"
      (closeSidebar)="bidSidebarService.close()"
      (approveBid)="bidSidebarService.emitApproveBid($event)"
    />
  </div>
}

@if (invoiceSidebarService.isOpen()) {
  <button
    id="invoice-sidebar-overlay"
    type="button"
    class="app-slide-sidebar-overlay fixed inset-0 z-[1200] bg-black/40 lg:bg-black/25"
    (click)="invoiceSidebarService.close()"
    [attr.aria-label]="'common.close' | translate"
  ></button>

  <div id="invoice-sidebar-container" class="app-slide-sidebar-container fixed top-0 right-0 z-[1300] h-screen w-full sm:w-[30rem] lg:w-[32rem]">
    <app-invoice-details-sidebar
      [data]="invoiceSidebarService.data()"
      (closeSidebar)="invoiceSidebarService.close()"
    />
  </div>
}
